import { PatientDocument, PatientDocumentVersion } from "@/apiGenerate/medserver";

export const getPatientDocumentVersion = (patientDocument: PatientDocument): PatientDocumentVersion | undefined => {
    let version: PatientDocumentVersion | undefined;
    if (patientDocument.versions) {
        version = patientDocument.versions
            .find(version => version.patientDocumentId === patientDocument.patientDocumentId);
    }

    return version;
}